import { match, P } from 'ts-pattern';
export function getNewSingleInstrumentationID(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
  // priority for setting singleInstrumentationID override rule
  // 1. from consumer event attribute
  // 2. from consumer configuration
  // 3. from cookie lib
  // 4. default behaviour generates through the crypto API
  return match({
    customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
    customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
  }).with({
    customSingleInstrumentationIDFromEvent: P.string
  }, function (result) {
    return result.customSingleInstrumentationIDFromEvent;
  }).with({
    customSingleInstrumentationIDFromUserConfig: P.string
  }, function (result) {
    return result.customSingleInstrumentationIDFromUserConfig;
  }).otherwise(function () {
    return crypto.randomUUID();
  });
}